module.exports = __webpack_public_path__ + "static/media/icon-_iconos-genericos-editar.48bb2d6c.svg";